import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorNoAuthCode, OAuth2AuthCodePKCE } from '../common/custom-lib/oauth2-auth-code-PKCE';
import { OAuth2Service } from '../common/services/oauth.service';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    isLoading: boolean = false;
    oAuth2Obj: OAuth2AuthCodePKCE;
    isFlowFailed = false;

    constructor(
        private _router: Router,
        private _oAuth2Service: OAuth2Service
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.oAuth2Obj = this._oAuth2Service.oAuth2;
        this.oAuth2Obj
            .isReturningFromAuthServer()
            .then(hasAuthCode => {
                if (!hasAuthCode) {
                    this.oAuth2Obj.fetchAuthorizationCode();
                }

                this.oAuth2Obj.getAccessToken().then(data => {
                    if (data) {
                        this.isLoading = false;
                        this._router.navigate(['/']);
                    }
                });
            })
            .catch(potentialError => {
                this.isLoading = false;
                if (!(potentialError instanceof ErrorNoAuthCode)) {
                    setTimeout(() => {
                        this.isFlowFailed = true;
                    }, 3000);
                }
            });
    }

    reLogin(): void {
        localStorage.clear();
        window.location.replace('/login');
    }
}
